






import Vue from "vue";

interface ITabState {
  value: number;
  update: (value: number) => void;
}

interface Provide {
  getTabState: () => ITabState;
}

export default Vue.extend({
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  provide(): Provide {
    return {
      getTabState: this.tabState
    };
  },

  methods: {
    tabState(): ITabState {
      return {
        value: this.value,
        update: this.updateIndex
      };
    },
    updateIndex(value: number) {
      this.$emit("input", value);
    }
  }
});
